$(function() {
	// Define the data for each field
	const data = {
		provincias: [
			{
				nombre: 'San José',
				cantones: [
					{
						nombre: 'San José',
						distritos: [
							'Carmen',
							'Merced',
							'Hospital',
							'Catedral',
							'Zapote',
							'San Francisco de Dos Ríos',
							'Uruca',
							'Mata Redonda',
							'Pavas',
							'Hatillo',
							'San Sebastián'
						]
					},
					{
						nombre: 'Escazú',
						distritos: ['Escazú', 'San Antonio', 'San Rafael']
					},
					{
						nombre: 'Desamparados',
						distritos: [
							'Desamparados',
							'San Miguel',
							'San Juan de Dios',
							'San Rafael Arriba',
							'San Antonio',
							'Frailes',
							'Patarrá',
							'San Cristóbal',
							'Rosario',
							'Damas',
							'San Rafael Abajo',
							'Gravilias',
							'Los Guido'
						]
					},
					{
						nombre: 'Puriscal',
						distritos: [
							'Santiago',
							'Mercedes Sur',
							'Barbacoas',
							'Grifo Alto',
							'San Rafael',
							'Candelarita',
							'Desamparaditos',
							'San Antonio',
							'Chires'
						]
					},
					{
						nombre: 'Tarrazú',
						distritos: ['San Marcos', 'San Lorenzo', 'San Carlos']
					},
					{
						nombre: 'Aserrí',
						distritos: [
							'Aserrí',
							'Tarbaca',
							'Vuelta de Jorco',
							'San Gabriel',
							'Legua',
							'Monterrey',
							'Salitrillos'
						]
					},
					{
						nombre: 'Mora',
						distritos: [
							'Colón',
							'Guayabo',
							'Tabarcia',
							'Piedras Negras',
							'Picagres',
							'Jaris',
							'Quitirrisí'
						]
					},
					{
						nombre: 'Goicoechea',
						distritos: [
							'Guadalupe',
							'San Francisco',
							'Calle Blancos',
							'Mata de Plátano',
							'Ipís',
							'Rancho Redondo',
							'Purral'
						]
					},
					{
						nombre: 'Santa Ana',
						distritos: [
							'Santa Ana',
							'Salitral',
							'Pozos',
							'Uruca',
							'Piedades',
							'Brasil'
						]
					},
					{
						nombre: 'Alajuelita',
						distritos: [
							'Alajuelita',
							'San Josecito',
							'San Antonio',
							'Concepción',
							'San Felipe'
						]
					},
					{
						nombre: 'Vázquez de Coronado',
						distritos: [
							'San Isidro',
							'San Rafael',
							'Dulce Nombre de Jesús',
							'Patalillo',
							'Cascajal'
						]
					},
					{
						nombre: 'Acosta',
						distritos: [
							'San Ignacio',
							'Guaitil',
							'Palmichal',
							'Cangrejal',
							'Sabanillas'
						]
					},
					{
						nombre: 'Tibás',
						distritos: [
							'San Juan',
							'Cinco Esquinas',
							'Anselmo Llorente',
							'León XIII',
							'Colima'
						]
					},
					{
						nombre: 'Moravia',
						distritos: [
							'San Vicente',
							'San Jerónimo',
							'La Trinidad'
						]
					},
					{
						nombre: 'Montes de Oca',
						distritos: [
							'San Pedro',
							'Sabanilla',
							'Mercedes',
							'San Rafael'
						]
					},
					{
						nombre: 'Turrubares',
						distritos: [
							'San Pablo',
							'San Pedro',
							'San Juan de Mata',
							'San Luis',
							'Carara'
						]
					},
					{
						nombre: 'Dota',
						distritos: ['Santa María', 'Jardín', 'Copey']
					},
					{
						nombre: 'Curridabat',
						distritos: [
							'Curridabat',
							'Granadilla',
							'Sánchez',
							'Tirrases'
						]
					},
					{
						nombre: 'Pérez Zeledón',
						distritos: [
							'San Isidro de El General',
							'El General',
							'Daniel Flores',
							'Rivas',
							'San Pedro',
							'Platanares',
							'Pejibaye',
							'Cajón',
							'Barú',
							'Río Nuevo',
							'Páramo',
							'La Amistad'
						]
					},
					{
						nombre: 'León Cortés Castro',
						distritos: [
							'San Pablo',
							'San Andrés',
							'Llano Bonito',
							'San Isidro',
							'Santa Cruz',
							'San Antonio'
						]
					}
				]
			},
			{
				nombre: 'Alajuela',
				cantones: [
					{
						nombre: 'Alajuela',
						distritos: [
							'Alajuela',
							'San José',
							'Carrizal',
							'San Antonio',
							'Guácima',
							'San Isidro',
							'Sabanilla',
							'San Rafael',
							'Río Segundo',
							'Desamparados',
							'Turrúcares',
							'Tambor',
							'Garita',
							'Sarapiquí'
						]
					},
					{
						nombre: 'San Ramón',
						distritos: [
							'San Ramón',
							'Santiago',
							'San Juan',
							'San Lorenzo',
							'Piedades Norte',
							'Piedades Sur',
							'San Rafael',
							'San Isidro',
							'Ángeles',
							'Alfaro',
							'Volio',
							'Concepción',
							'Zapotal',
							'Peñas Blancas'
						]
					},
					{
						nombre: 'Grecia',
						distritos: [
							'Grecia',
							'San Isidro',
							'San José',
							'San Roque',
							'Tacares',
							'Puente de Piedra',
							'Bolívar'
						]
					},
					{
						nombre: 'San Mateo',
						distritos: [
							'San Mateo',
							'Labrador',
							'Desmonte',
							'Jesús María'
						]
					},
					{
						nombre: 'Atenas',
						distritos: [
							'Atenas',
							'Jesús',
							'Mercedes',
							'San Isidro',
							'Concepción',
							'San José',
							'Santa Eulalia',
							'Escobal'
						]
					},
					{
						nombre: 'Naranjo',
						distritos: [
							'Naranjo',
							'San Miguel',
							'San José',
							'Cirrí Sur',
							'San Jerónimo',
							'San Juan',
							'El Rosario',
							'Palmitos'
						]
					},
					{
						nombre: 'Palmares',
						distritos: [
							'Palmares',
							'Zaragoza',
							'Buenos Aires',
							'Santiago',
							'Candelaria',
							'Esquipulas',
							'La Granja'
						]
					},
					{
						nombre: 'Poás',
						distritos: [
							'San Pedro',
							'San Juan',
							'San Rafael',
							'Carrillos',
							'Sabana Redonda'
						]
					},
					{
						nombre: 'Orotina',
						distritos: [
							'Orotina',
							'Mastate',
							'Hacienda Vieja',
							'Coyolar',
							'La Ceiba'
						]
					},
					{
						nombre: 'San Carlos',
						distritos: [
							'Quesada',
							'Florencia',
							'Buenavista',
							'Aguas Zarcas',
							'Venecia',
							'Pital',
							'La Fortuna',
							'La Tigra',
							'La Palmera',
							'Venado',
							'Cutris',
							'Monterrey',
							'Pocosol'
						]
					},
					{
						nombre: 'Zarcero',
						distritos: [
							'Zarcero',
							'Laguna',
							'Tapesco',
							'Guadalupe',
							'Palmira',
							'Zapote',
							'Brisas'
						]
					},
					{
						nombre: 'Valverde Vega',
						distritos: [
							'Sarchí Norte',
							'Sarchí Sur',
							'Toro Amarillo',
							'San Pedro',
							'Rodríguez'
						]
					},
					{
						nombre: 'Upala',
						distritos: [
							'Upala',
							'Aguas Claras',
							'San José (Pizote)',
							'Bijagua',
							'Delicias',
							'Dos Ríos',
							'Yolillal'
						]
					},
					{
						nombre: 'Los Chiles',
						distritos: [
							'Los Chiles',
							'Caño Negro',
							'El Amparo',
							'San Jorge'
						]
					},
					{
						nombre: 'Guatuso',
						distritos: [
							'San Rafael',
							'Buenavista',
							'Cote',
							'Katira'
						]
					},
					{
						nombre: 'Río Cuarto',
						distritos: ['Río Cuarto', 'Santa Isabel', 'Santa Rita']
					}
				]
			},
			{
				nombre: 'Cartago',
				cantones: [
					{
						nombre: 'Cartago',
						distritos: [
							'Oriental',
							'Occidental',
							'Carmen',
							'San Nicolás',
							'Aguacaliente (San Francisco)',
							'Guadalupe (Arenilla)',
							'Corralillo',
							'Tierra Blanca',
							'Dulce Nombre',
							'Llano Grande',
							'Quebradilla'
						]
					},
					{
						nombre: 'Paraíso',
						distritos: [
							'Paraíso',
							'Santiago de Paraíso',
							'Orosi',
							'Cachí',
							'Llanos de Santa Lucía'
						]
					},
					{
						nombre: 'La Unión',
						distritos: [
							'Tres Ríos',
							'San Diego',
							'San Juan',
							'San Rafael',
							'Concepción',
							'Dulce Nombre',
							'San Ramón',
							'Río Azul'
						]
					},
					{
						nombre: 'Jiménez',
						distritos: ['Juan Viñas', 'Tucurrique', 'Pejibaye']
					},
					{
						nombre: 'Turrialba',
						distritos: [
							'Turrialba',
							'La Suiza',
							'Peralta',
							'Santa Cruz',
							'Santa Teresita',
							'Pavones',
							'Tuis',
							'Tayutic',
							'Santa Rosa',
							'Tres Equis',
							'La Isabel',
							'Chirripó'
						]
					},
					{
						nombre: 'Alvarado',
						distritos: ['Pacayas', 'Cervantes', 'Capellades']
					},
					{
						nombre: 'Oreamuno',
						distritos: [
							'San Rafael',
							'Cot',
							'Potrero Cerrado',
							'Cipreses',
							'Santa Rosa'
						]
					},
					{
						nombre: 'El Guarco',
						distritos: [
							'El Tejar',
							'San Isidro',
							'Tobosi',
							'Patio de Agua'
						]
					}
				]
			},
			{
				nombre: 'Heredia',
				cantones: [
					{
						nombre: 'Heredia',
						distritos: [
							'Heredia',
							'Mercedes',
							'San Francisco',
							'Ulloa',
							'Vara Blanca'
						]
					},
					{
						nombre: 'Barva',
						distritos: [
							'Barva',
							'San Pedro',
							'San Pablo',
							'San Roque',
							'Santa Lucía',
							'San José de la Montaña'
						]
					},
					{
						nombre: 'Santo Domingo',
						distritos: [
							'Santo Domingo',
							'San Vicente',
							'San Miguel',
							'Paracito',
							'Santo Tomás',
							'Santa Rosa',
							'Tures',
							'Pará'
						]
					},
					{
						nombre: 'Santa Bárbara',
						distritos: [
							'Santa Bárbara',
							'San Pedro',
							'San Juan',
							'Jesús',
							'Santo Domingo',
							'Purabá'
						]
					},
					{
						nombre: 'San Rafael',
						distritos: [
							'San Rafael',
							'San Josecito',
							'Santiago',
							'Ángeles',
							'Concepción'
						]
					},
					{
						nombre: 'San Isidro',
						distritos: [
							'San Isidro',
							'San José',
							'Concepción',
							'San Francisco'
						]
					},
					{
						nombre: 'Belén',
						distritos: ['San Antonio', 'La Ribera', 'La Asunción']
					},
					{
						nombre: 'Flores',
						distritos: ['San Joaquín', 'Barrantes', 'Llorente']
					},
					{
						nombre: 'San Pablo',
						distritos: ['San Pablo', 'Rincón de Sabanilla']
					},
					{
						nombre: 'Sarapiquí',
						distritos: [
							'Puerto Viejo',
							'La Virgen',
							'Horquetas',
							'Llanuras del Gaspar',
							'Cureña'
						]
					}
				]
			},
			{
				nombre: 'Guanacaste',
				cantones: [
					{
						nombre: 'Liberia',
						distritos: [
							'Liberia',
							'Cañas Dulces',
							'Mayorga',
							'Nacascolo',
							'Curubandé'
						]
					},
					{
						nombre: 'Nicoya',
						distritos: [
							'Nicoya',
							'Mansión',
							'San Antonio',
							'Quebrada Honda',
							'Sámara',
							'Nosara',
							'Belén de Nosarita'
						]
					},
					{
						nombre: 'Santa Cruz',
						distritos: [
							'Santa Cruz',
							'Bolsón',
							'Veintisiete de Abril',
							'Tempate',
							'Cartagena',
							'Cuajiniquil',
							'Diriá',
							'Cabo Velas',
							'Tamarindo'
						]
					},
					{
						nombre: 'Bagaces',
						distritos: [
							'Bagaces',
							'Fortuna',
							'Mogote',
							'Río Naranjo'
						]
					},
					{
						nombre: 'Carrillo',
						distritos: [
							'Filadelfia',
							'Palmira',
							'Sardinal',
							'Belén'
						]
					},
					{
						nombre: 'Cañas',
						distritos: [
							'Cañas',
							'Palmira',
							'San Miguel',
							'Bebedero',
							'Porozal'
						]
					},
					{
						nombre: 'Abangares',
						distritos: [
							'Las Juntas',
							'Sierra',
							'San Juan',
							'Colorado'
						]
					},
					{
						nombre: 'Tilarán',
						distritos: [
							'Tilarán',
							'Cabeceras',
							'Quebrada Grande',
							'Tronadora',
							'Santa Rosa',
							'Líbano',
							'Tierras Morenas',
							'Arenal'
						]
					},
					{
						nombre: 'Nandayure',
						distritos: [
							'Carmona',
							'Santa Rita',
							'Zapotal',
							'San Pablo',
							'Porvenir',
							'Bejuco'
						]
					},
					{
						nombre: 'La Cruz',
						distritos: [
							'La Cruz',
							'Santa Cecilia',
							'La Garita',
							'Santa Elena'
						]
					},
					{
						nombre: 'Hojancha',
						distritos: [
							'Hojancha',
							'Monte Romo',
							'Puerto Carrillo',
							'Huacas',
							'Matambú'
						]
					}
				]
			},
			{
				nombre: 'Puntarenas',
				cantones: [
					{
						nombre: 'Puntarenas',
						distritos: [
							'Puntarenas',
							'Pitahaya',
							'El Roble',
							'Arancibia',
							'Chomes',
							'Lepanto',
							'Paquera',
							'Manzanillo',
							'Guacimal',
							'Barranca',
							'Monte Verde',
							'Isla del Coco',
							'Cóbano',
							'Chacarita',
							'Chira',
							'Acapulco'
						]
					},
					{
						nombre: 'Esparza',
						distritos: [
							'Espíritu Santo',
							'San Juan Grande',
							'Macacona',
							'San Rafael',
							'San Jerónimo',
							'Caldera'
						]
					},
					{
						nombre: 'Buenos Aires',
						distritos: [
							'Buenos Aires',
							'Volcán',
							'Potrero Grande',
							'Boruca',
							'Pilas',
							'Colinas',
							'Chánguena',
							'Biolley',
							'Brunka'
						]
					},
					{
						nombre: 'Montes de Oro',
						distritos: ['Miramar', 'La Unión', 'San Isidro']
					},
					{
						nombre: 'Osa',
						distritos: [
							'Cortés',
							'Palmar',
							'Sierpe',
							'Bahía Ballena',
							'Piedras Blancas',
							'Bahía Drake'
						]
					},
					{
						nombre: 'Quepos',
						distritos: ['Quepos', 'Savegre', 'Naranjito']
					},
					{
						nombre: 'Golfito',
						distritos: ['Golfito', 'Guaycará', 'Pavón']
					},
					{
						nombre: 'Coto Brus',
						distritos: [
							'San Vito',
							'Gutiérrez Braun',
							'Sabalito',
							'Aguabuena',
							'Limoncito',
							'Pittier'
						]
					},
					{
						nombre: 'Parrita',
						distritos: ['Parrita']
					},
					{
						nombre: 'Corredores',
						distritos: [
							'Corredor',
							'La Cuesta',
							'Paso Canoas',
							'Laurel'
						]
					},
					{
						nombre: 'Garabito',
						distritos: ['Jacó', 'Tárcoles']
					}
				]
			},
			{
				nombre: 'Limón',
				cantones: [
					{
						nombre: 'Limón',
						distritos: [
							'Limón',
							'Valle La Estrella',
							'Río Blanco',
							'Matama'
						]
					},
					{
						nombre: 'Pococí',
						distritos: [
							'Guápiles',
							'Jiménez',
							'Rita',
							'Roxana',
							'Cariari',
							'Colorado',
							'La Colonia'
						]
					},
					{
						nombre: 'Siquirres',
						distritos: [
							'Siquirres',
							'Pacuarito',
							'Reventazón',
							'Florida',
							'Germania',
							'Cairo',
							'Alegría'
						]
					},
					{
						nombre: 'Talamanca',
						distritos: ['Bratsi', 'Sixaola', 'Cahuita', 'Telire']
					},
					{
						nombre: 'Matina',
						distritos: ['Matina', 'Batán', 'Carrandi']
					},
					{
						nombre: 'Guácimo',
						distritos: [
							'Guácimo',
							'Mercedes',
							'Pocora',
							'Río Jiménez',
							'Duacarí'
						]
					}
				]
			}
		]
	};

	// Populate the Provincia field
	var provincias = data['provincias'];
	$.each(provincias, function(index, provincia) {
		$('#provincia').append(
			'<option value="' +
				provincia.nombre +
				'">' +
				provincia.nombre +
				'</option>'
		);
	});

	// Populate the Canton field based on the selected Provincia
	$('#provincia').change(function() {
		var selectedProvincia = $(this).val();
		var cantones = [];
		$.each(provincias, function(index, provincia) {
			if (provincia.nombre === selectedProvincia) {
				cantones = provincia.cantones;
			}
		});
		$('#canton').empty();
		$('#distrito').empty();
		$('#canton').append(
			'<option selected disabled value="">Seleccione una opción</option>'
		);
		$('#distrito').append(
			'<option selected disabled value="">Seleccione una opción</option>'
		);
		$.each(cantones, function(index, canton) {
			$('#canton').append(
				'<option value="' +
					canton.nombre +
					'">' +
					canton.nombre +
					'</option>'
			);
		});
	});

	// Populate the Distrito field based on the selected Provincia and Canton
	$('#canton').change(function() {
		var selectedProvincia = $('#provincia').val();
		var selectedCanton = $(this).val();
		var distritos = [];
		$.each(provincias, function(index, provincia) {
			if (provincia.nombre === selectedProvincia) {
				$.each(provincia.cantones, function(index, canton) {
					if (canton.nombre == selectedCanton) {
						distritos = canton.distritos;
					}
				});
			}
		});
		$('#distrito').empty();
		$('#distrito').append(
			'<option selected disabled value="">Seleccione una opción</option>'
		);
		$.each(distritos, function(index, distrito) {
			$('#distrito').append(
				'<option value="' + distrito + '">' + distrito + '</option>'
			);
		});
	});

	function mergeJSONValues(jsonData) {
		var mergedJson = [];

		$.each(jsonData, function(index, item) {
			var foundIndex = -1;

			$.each(mergedJson, function(i, mergedItem) {
				if (mergedItem.name === item.name) {
					foundIndex = i;
					return false; // Exit the inner loop
				}
			});

			if (foundIndex > -1) {
				mergedJson[foundIndex].value += ', ' + item.value;
			} else {
				mergedJson.push({ name: item.name, value: item.value });
			}
		});

		if (mergedJson[10].name != 'tech_requirements') {
			mergedJson.splice(10, 0, {
				name: 'tech_requirements',
				value: ''
			});
		}

		var newJSON = {};
		var counter = 1;
		$.each(mergedJson, function(index, item) {
			if (counter == 2) counter++;
			var propertyName = 'input_' + counter;
			newJSON[propertyName] = item.value;
			counter++;
		});
		return newJSON;
	}

	// Custom validation method for phone number format
	jQuery.validator.addMethod(
		'phoneNumberFormat',
		function(value, element) {
			// Regular expressions for national and international phone number formats
			var nationalFormat = /^[0-9]{8}$/; // Example: 12345678
			var internationalFormat = /^\+[0-9]{1,3}[0-9]{8,}$/; // Example: +11234567890

			return (
				this.optional(element) ||
				nationalFormat.test(value) ||
				internationalFormat.test(value)
			);
		},
		'Escriba un número de teléfono válido'
	);

	// Custom validation method for identification format
	$.validator.addMethod(
		'identificacionFormat',
		function(value, element) {
			var nacionalidad = $('#nacionalidad').val();

			if (nacionalidad === 'Nacional') {
				// Nacional: 9 dígitos exactamente
				var regex = /^\d{9}$/;
				return this.optional(element) || regex.test(value);
			} else if (nacionalidad === 'Extranjero') {
				// Extranjero: Máximo 20 caracteres alfanuméricos
				var regex = /^[a-zA-Z0-9]{1,20}$/;
				return this.optional(element) || regex.test(value);
			} else {
				// Otra opción: campo no válido
				return false;
			}
		},
		'Por favor, ingresa un número de identificación válido'
	);

	$.validator.addMethod(
		'brthd',
		function(value, element) {
			var today = new Date();
			var birthdate = new Date(value);
			var age = today.getFullYear() - birthdate.getFullYear();
			var monthDiff = today.getMonth() - birthdate.getMonth();

			if (
				monthDiff < 0 ||
				(monthDiff === 0 && today.getDate() < birthdate.getDate())
			) {
				age--;
			}

			return age >= 18;
		},
		'Debes tener al menos 18 años'
	);

	$.validator.addMethod(
		'ensureEmail',
		function validateEmail(value, element) {
			// Regular expression for email validation
			var regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
			return regex.test(value);
		},
		'Email inválido'
	);

	var form = $('#pl_forms_multi-step-form');
	var currentStep = 1;
	const total = $('[id^=step-]').length;

	// Validations
	form.validate({
		rules: {
			// Step 1 validation
			area: {
				required: true
			},
			partnership: {
				required: true
			},
			activity: {
				required: true
			},

			//Courses form
			nombre: {
				required: true
			},
			nacionalidad: {
				required: true
			},
			identification: {
				required: true,
				identificacionFormat: true
			},

			// Step 2 validation
			contact_name: {
				required: true
			},
			phone: {
				required: true
			},
			email: {
				required: true,
				email: true,
				ensureEmail: true
			},

			//Courses form
			birthdate: {
				required: true,
				date: true,
				brthd: true
			},
			discapacidad: {
				required: true
			},

			// Step 3 validation
			place: {
				required: true
			},
			activity_name: {
				required: true
			},
			activity_type: {
				required: true
			},
			participants: {
				required: true,
				digits: true
			},

			//Courses form
			provincia: {
				required: true
			},
			canton: {
				required: true
			},
			distrito: {
				required: true
			},

			// Step 4 validation

			//Courses form
			telefono: {
				required: true,
				phoneNumberFormat: true
			}
		},
		messages: {
			//Step 1 messages
			area: 'Campo requerido',
			partnership: 'Campo requerido',
			activity: 'Campo requerido',

			//Courses form
			nombre: 'Campo requerido',
			nacionalidad: 'Campo requerido',
			identification: {
				required: 'Campo requerido',
				identificacionFormat:
					'Por favor, ingresa un número de identificación válido'
			},

			//Step 2 messages
			contact_name: 'Campo requerido',
			phone: 'Campo requerido',
			email: {
				required: 'Campo requerido',
				email: 'Se debe ingresar un correo válido',
				ensureEmail: 'Se debe ingresar un correo válido'
			},

			//Courses form
			birthdate: {
				required: 'Campo requerido',
				date: 'Debe ingresar una fecha válida',
				brthd: 'Debe tener al menos 18 años'
			},
			discapacidad: 'Campo requerido',

			//Step 3 messages
			place: 'Campo requerido',
			date_activity: {
				required: 'Campo requerido'
			},
			activity_name: 'Campo requerido',
			activity_type: 'Campo requerido',
			participants: {
				required: 'Campo requerido',
				digits: 'Solo se aceptan números'
			},
			tech_requirements: 'Campo requerido',

			//Courses form
			provincia: 'Campo requerido',
			canton: 'Campo requerido',
			distrito: 'Campo requerido',

			//Step 4 messages

			//Courses form
			telefono: {
				required: 'Campo requerido',
				phoneNumberFormat:
					'Escriba un número de teléfono válido. Ejemplos:  +11234567890 o 12345678'
			}
		},
		errorPlacement: function(error, element) {
			var errorId = element.attr('id') + '-error';
			$('#' + errorId).html(error);
		}
	});

	// Next button click event
	$('.next-step').click(function() {
		if (form.valid()) {
			$('#step-' + currentStep).addClass('animate__fadeOutLeft');
			currentStep++;
			setTimeout(function() {
				$('#step-' + (currentStep - 1))
					.hide()
					.removeClass('animate__fadeOutLeft');
				$('#pl_pb_form').css(
					'width',
					(currentStep / total) * 100 + '%'
				);
				$('#pl_forms_pb_indicator_current').text(currentStep);
				$('#step-' + currentStep)
					.show()
					.addClass('animate__fadeInRight');
				setTimeout(function() {
					$('#step-' + currentStep).removeClass(
						'animate__fadeInRight'
					);
				}, 1000);
			}, 1000);

			//$("#step-" + currentStep).fadeIn(1000);
			if (currentStep == total) {
				$(this).hide();
				$('.pl_forms_btn_submit').show();
			}
			if (currentStep == 2) {
				$('#pl_forms_part').text('Parte ' + currentStep + '/' + 2);
				$('#pl_forms_info_label1').hide();
				$('#pl_forms_info_label2').show();
			}
			$('.prev-step').show();
			$('html, body').animate({ scrollTop: 100 }, 'slow');
		}
	});

	// Previous button click event
	$('.prev-step').click(function() {
		$('#step-' + currentStep).addClass('animate__fadeOutRight');
		currentStep--;
		setTimeout(function() {
			$('#step-' + (currentStep + 1))
				.hide()
				.removeClass('animate__fadeOutRight');
			$('#pl_pb_form').css('width', (currentStep / total) * 100 + '%');
			$('#pl_forms_pb_indicator_current').text(currentStep);
			$('#step-' + currentStep)
				.show()
				.addClass('animate__fadeInLeft');
			setTimeout(function() {
				$('#step-' + currentStep).removeClass('animate__fadeInLeft');
			}, 1000);
		}, 1000);

		if (currentStep == 1) {
			$(this).hide();
			$('#pl_forms_part').text('Parte ' + currentStep + '/' + 2);
			$('#pl_forms_info_label2').hide();
			$('#pl_forms_info_label1').show();
		}

		$('.pl_forms_btn_submit').hide();
		$('.next-step').show();
		$('html, body').animate({ scrollTop: 100 }, 'slow');
	});

	$.each($('input[name="place"]'), function() {
		$(this).on('change', function(e) {
			if ($('input[name="place"]:checked').length === 0) {
				$('#place-error')
					.text('Campo requerido')
					.show();
			} else
				$('#place-error')
					.text('Campo requerido')
					.hide();
		});
	});

	$('.pl_forms_btn_submit').click(function(e) {
		let submit_btn = $(this);
		if ($('input[name="place"]:checked').length === 0) {
			e.preventDefault();
			$('#place-error')
				.text('Campo requerido')
				.show();
			return;
		}
		if (form.valid()) {
			submit_btn.prop('disabled', true);
			const textBtn = submit_btn.text();
			submit_btn.text('Enviando...');
			var recaptchaResponse = grecaptcha.getResponse(); // Get the reCAPTCHA response

			if (recaptchaResponse === '') {
				alert('Por favor completar la validación de reCAPTCHA.');
				return;
			}

			$.ajax({
				url: form.data('ajaxphp'),
				type: 'POST',
				data: {
					action: 'validate_captcha',
					recaptchaResponse: recaptchaResponse
				},
				success: function() {
					var formData = form.serializeArray();
					var mergedJSON = mergeJSONValues(formData);
					$.ajax({
						url: form.data('ajaxphp'),
						type: 'POST',
						data: {
							action: 'validate_captcha',
							recaptchaResponse: recaptchaResponse
						},
						success: function() {
							// Assuming customSubmitButton is the ID of your external button and #yourFormID is the ID of your form
							$('#customSubmitButton').click(function() {
								$('#pl_forms_multi-step-form').submit();
							});
						},
						error: function() {
							alert('Error connecting to validate_captcha');
							submit_btn.prop('disabled', false);
							submit_btn.text(textBtn);
						}
					});
				},
				error: function() {
					alert('error al contectat a la validate_captcha');
					submit_btn.prop('disabled', false);
					submit_btn.text(textBtn);
				}
			});
		}
	});

	$('#pl_pb_form').css('width', (currentStep / total) * 100 + '%');
	$('#pl_forms_pb_indicator_current').text(currentStep);
	$('#pl_forms_pb_indicator_last').text(total);
});
